export enum UserProjection {
    permissions = 'permissions',
    educations = 'educations',
    securityClearence = 'securityClearence',
    email = 'email',
    activity = 'activity',
    dataTable = 'dataTable',
    select = 'select',
    form = 'form',
}
